import React, { useMemo, useRef, memo } from 'react';
import { motion } from 'framer-motion';
// import { toPng } from 'html-to-image';
// import { Button } from './ui/button';
import { cn } from '../lib/utils';

// const Category = {
//   EXACT_DEVICE: 'exact-with-device',
//   EXACT_NO_DEVICE: 'exact-without-device',
//   ABSTRACT_DEVICE: 'abstract-with-device',
//   ABSTRACT_NO_DEVICE: 'abstract-without-device',
//   AUTO: 'auto',
// };

const MockupCanvas = memo(function MockupCanvas({ imageUrl, category, deviceType, showDevice, fileCount = 1, onDownload, onShare, enhancedImageUrl, enhancedImageData, isEnhanced, enhancedResolution, nativeResolution, onDeleteImage, mockupId, zoomLevel = 1.0 }) {
  const ref = useRef(null);

  const { layoutClass } = useMemo(() => {
    // const base = 'rounded-2xl overflow-hidden bg-black';
    
    // Always use full width for all cases with 4:3 landscape aspect ratio
    if (fileCount >= 3) {
      return { 
        layoutClass: 'isometric-layout'
      };
    }
    
    // For 2 files, use 4:3 landscape aspect ratio and full width
    if (fileCount === 2) {
      return { 
        layoutClass: 'composite-layout'
      };
    }
    
    // For single files, use full width with 4:3 landscape aspect ratio
    return { 
      layoutClass: 'device-layout'
    };
  }, [fileCount]);


  // const showBezel = showDevice && (category === 'simple' || category === 'office' || category === 'fiori' || category === 'stones');

  // async function handleDownload() {
  //   if (!ref.current) return;
  //   try {
  //     const dataUrl = await toPng(ref.current, { 
  //       pixelRatio: 2,
  //       backgroundColor: '#ffffff',
  //       quality: 1.0,
  //       cacheBust: true
  //     });
  //     const a = document.createElement('a');
  //     a.href = dataUrl;
  //     a.download = 'randommockup.png';
  //     a.click();
  //     onDownload?.(dataUrl);
  //   } catch (error) {
  //     console.error('Download failed:', error);
  //   }
  // }

  // async function handleShare() {
  //   if (!ref.current) return;
  //   try {
  //     const dataUrl = await toPng(ref.current, { 
  //       pixelRatio: 2,
  //       backgroundColor: '#ffffff',
  //       quality: 1.0,
  //       cacheBust: true
  //     });
  //     if (navigator.share && navigator.canShare) {
  //       try {
  //         const blob = await (await fetch(dataUrl)).blob();
  //         const file = new File([blob], 'randommockup.png', { type: 'image/png' });
  //         if (navigator.canShare({ files: [file] })) {
  //           await navigator.share({ files: [file], title: 'RandomMockups', text: 'Made with RandomMockups' });
  //           onShare?.();
  //           return;
  //         }
  //       } catch {}
  //     }
  //     const a = document.createElement('a');
  //     a.href = dataUrl;
  //     a.download = 'randommockup.png';
  //     a.click();
  //   } catch (error) {
  //     console.error('Share failed:', error);
  //   }
  // }

  // Get enhanced image URL
  const enhancedUrl = enhancedImageUrl || enhancedImageData;

  return (
    <div className="w-full" style={{ overflow: zoomLevel > 1.0 ? 'auto' : 'hidden' }}>
      {isEnhanced && enhancedUrl ? (
        // Enhanced view with horizontal scroll
        <motion.div
          className={cn("w-full overflow-hidden mockup-canvas", layoutClass)}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          ref={ref}
          data-mockup-id={mockupId}
          style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center' }}
        >
          <div className="flex overflow-x-auto snap-x snap-mandatory enhanced-mockup-scroll gap-2">
            {/* Enhanced Image */}
            <div 
              className="flex-shrink-0 w-full relative snap-center"
            >
              <img 
                src={enhancedUrl} 
                alt="enhanced mockup" 
                className="w-full object-contain"
              />
              {/* Enhanced Pill */}
              <div className="absolute top-6 right-6">
                <div className="bg-black/50 backdrop-blur-sm text-white px-3 py-1 rounded-lg text-sm font-medium">
                  {enhancedResolution ? enhancedResolution.toUpperCase() : 'Enhanced'}
                </div>
              </div>
            </div>
            
            {/* Original Image */}
            <div 
              className="flex-shrink-0 w-full relative snap-center"
            >
              <img 
                src={imageUrl} 
                alt="original mockup" 
                className="w-full object-contain"
              />
              {/* Original Pill */}
              <div className="absolute top-6 right-6">
                <div className="bg-black/50 backdrop-blur-sm text-white px-3 py-1 rounded-lg text-sm font-medium">
                  Original
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      ) : (
        // Original single image view
        <motion.div
          className={cn("w-full overflow-hidden mockup-canvas relative", layoutClass)}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          ref={ref}
          data-mockup-id={mockupId}
          style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center center' }}
        >
        <img 
          src={imageUrl} 
          alt="mockup" 
          className="w-full object-contain"
          key={mockupId}
          onError={(e) => {
            // Fallback to enhanced image if main image fails to load
            if (enhancedUrl && e.target.src !== enhancedUrl) {
              e.target.src = enhancedUrl;
            }
          }}
        />
        {/* Native Resolution Badge (for Gemini 3 Pro 2K output) */}
        {nativeResolution && (
          <div className="absolute top-6 right-6">
            <div className="bg-black/50 backdrop-blur-sm text-white px-3 py-1 rounded-lg text-sm font-medium">
              {nativeResolution.toUpperCase()}
            </div>
          </div>
        )}
        </motion.div>
      )}
    </div>
  );
});

export default MockupCanvas;


